var _rect, _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndus8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 12.5,
    width: 51,
    height: 39,
    rx: 7.5,
    stroke: "#000064"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 12V6.5C35 5.15541 34.1606 3.80468 32.5261 2.74225C30.9011 1.68599 28.5965 1 26 1C23.4035 1 21.0989 1.68599 19.4739 2.74225C17.8394 3.80468 17 5.15541 17 6.5V12H16V6.5C16 2.91015 20.4772 0 26 0C31.5228 0 36 2.91015 36 6.5V12H35Z",
    fill: "#000064"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 31.5,
    r: 11,
    stroke: "#000064"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 27V36",
    stroke: "#000064"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 31.5H21",
    stroke: "#000064"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndus8);
export default __webpack_public_path__ + "static/media/indus8.43e8bc1e3e6b1e39852ed68f371b9d65.svg";
export { ForwardRef as ReactComponent };